<template>
  <div class="whiteoutertab paddingallll" id="tabtop">
    <div class="tab">
      <div class="tablogo">
        <a href>
          <img :src="logo.logo" />
        </a>
      </div>
      <ul class="tabs">
        <a href="javascript:void(0);">
          <li class="itemtab" :class=" activename =='home'? 'boder_bottom' : ''" @click="goPage('home')">首页</li>
        </a>
        <!-- <li>/</li> -->
        <a href="javascript:void(0);" class="aboutitem">
          <li
            class="itemtab aboutitem"
            :class=" activename =='about'? 'boder_bottom' : ''"
            @click="goPage('about')"
            style="position: relative;"
          >
            关于我们
            <div class="abouttwo">
              <div @click="aboutClickone">公司介绍</div>
              <div @click="aboutClicktwo">企业文化</div>
              <div @click="aboutClickthree">发展历程</div>
              <div @click="aboutClickfour">荣誉资质</div>
            </div>
          </li>
        </a>
        <!-- <li>/</li> -->
        <a href="javascript:void(0);">
          <li class="itemtab" :class=" activename =='project'? 'boder_bottom' : ''" @click="goPage('project')">产品展示</li>
        </a>
        <!-- <li>/</li> -->
        <a href="javascript:void(0);" class="newsitemtab">
          <li
            class="itemtab newsitemtab"
            :class=" activename =='news'? 'boder_bottom' : ''"
            @click="goPage('news')"
            style="position: relative;"
          >
            新闻资讯
            <div class="newstwo">
              <div @click="newsClick(1)">公司活动</div>
              <div @click="newsClick(2)">行业新闻</div>
            </div>
          </li>
        </a>
        <!-- <li>/</li> -->
        <a href="javascript:void(0);">
          <li
            class="itemtab"
            :class=" activename =='recruitment'? 'boder_bottom' : ''"
            @click="goPage('recruitment')"
          >人才招聘</li>
        </a>
        <!-- <li>/</li> -->
        <a href="javascript:void(0);">
          <li class="itemtab" :class=" activename =='contact'? 'boder_bottom' : ''" @click="goPage('contact')">联系我们</li>
        </a>
      </ul>

      <!-- 隐藏tab -->

      <div class="toptabicon" @click="onClick" v-show="!show">
        <img src="/static/列表.png" />
      </div>

      <div class="ularea aaa" v-show="show">
        <div class="ulclose">
          <img src="/static/叉.png" @click="onClose" />
        </div>
        <div class="ulimg">
          <img :src="logo.phoneLogo" />
        </div>

        <ul class="tabstab">
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='home'? 'boder_bottom' : ''"
            @click="goPage('home')"
          >首页</li>
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='about'? 'boder_bottom' : ''"
            @click="goPage('about')"
          >关于我们</li>
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='project'? 'boder_bottom' : ''"
            @click="goPage('project')"
          >产品展示</li>
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='news'? 'boder_bottom' : ''"
            @click="goPage('news')"
          >新闻资讯</li>
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='recruitment'? 'boder_bottom' : ''"
            @click="goPage('recruitment')"
          >人才招聘</li>
          <li
            class="itemtabtab animated fadeInUp"
            :class=" activename =='contact'? 'boder_bottom' : ''"
            @click="goPage('contact')"
          >联系我们</li>
        </ul>

        <!-- <div class="ulword">EN</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      activename: "",
      show: false,
      logo: ""
    }
  },
  methods: {
    goPage(name) {
      this.$router.push({ name });
      window.isFirst = 1
    },
    onClick() {
      this.show = true
    },
    onClose() {
      this.show = false
    },
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.companyInfo, {})
        .then(res => {
          console.log(res.data);
          let { error_code, companyInfo } = res.data;
          if (error_code == 2001) {
            this.logo = companyInfo
          }
        });
    },
    aboutClickone() {
      $('#toplink').addClass('toplinkone')
      if (this.$route.path == "/about") {
        $(window).scrollTop($('#firsttitle').offset().top - 100)
      } else {
        this.$router.push({ name: "/about" })
        setTimeout(() => {
          $(window).scrollTop($('#firsttitle').offset().top - 100)
        }, 200);
      }
    },
    aboutClicktwo() {
      $('#toplink').addClass('toplinkone')
      if (this.$route.path == "/about") {
        $(window).scrollTop($('#secondtitle').offset().top - 100)
      } else {
        this.$router.push({ name: "/about" })
        setTimeout(() => {
          $(window).scrollTop($('#secondtitle').offset().top - 100)
        }, 200);
      }
    },
    aboutClickthree() {
      $('#toplink').addClass('toplinkone')
      if (this.$route.path == "/about") {
        $(window).scrollTop($('#thirdtitle').offset().top - 100)
      } else {
        this.$router.push({ name: "/about" })
        setTimeout(() => {
          $(window).scrollTop($('#thirdtitle').offset().top - 100)
        }, 200);
      }
    },
    aboutClickfour() {
      $('#toplink').addClass('toplinkone')
      if (this.$route.path == "/about") {
        $(window).scrollTop($('#fourtitle').offset().top - 100)
      } else {
        this.$router.push({ name: "/about" })
        setTimeout(() => {
          $(window).scrollTop($('#fourtitle').offset().top - 100)
        }, 200);
      }
    },
    newsClick(e) {
      console.log(e);
      if (this.$route.path == "/news") {
        this.$e.$emit("newsone", e)
      } else {
        this.$router.push({ name: "/news" })
        setTimeout(() => {
          this.$e.$emit("newsone", e)
        }, 100);

      }
    }
  },
  created() {
    this.activename = this.$route.name
    this.loadData();
  }
}
</script>

<style>
.toplinkone {
  display: block !important;
}

.linkicon {
  font-size: 33px;
  line-height: 30px;
}
.aboutitem:hover .abouttwo {
  display: block;
}
.abouttwo {
  position: absolute;
  top: 0.67rem;
  width: 140px;
  background-color: #eaeaea;
  /* display: flex; */
  font-size: 16px;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  color: black;
  line-height: 45px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.newsitemtab:hover .newstwo {
  display: block;
}
.newstwo {
  position: absolute;
  top: 0.67rem;
  width: 140px;
  background-color: #eaeaea;
  /* display: flex; */
  font-size: 16px;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  color: black;
  line-height: 45px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.whiteoutertab {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 0.67rem;
  position: fixed;
  top: 0;
  z-index: 2000;
  /* min-width: 1320px; */
}

.tab {
  width: 1540px;
  height: 0.67rem;
  display: flex;
  justify-content: space-between;
  /* padding: 0 7.6%; */
  background-color: rgba(255, 255, 255, 1);
  z-index: 100;
  margin: 0 auto;
  /* min-width: 990px; */
}
.tablogo {
  /* width: 3rem; */
  height: 0.3rem;
  margin: auto 0;
}

.tablogo img {
  /* width: 3rem; */
  height: 0.4rem;

  display: block;
}
.tabs {
  /* width: 5rem; */
  height: 0.67rem;
  line-height: 0.67rem;
  font-size: 18px;
  color: black;
  display: flex;
  justify-content: space-between;
}

.tabs li {
  height: 0.55rem;
  margin-left: 60px;
}
.tabs li.itemtab:hover {
  border-bottom: 2px solid #ff6900;
  color: #ff6900;
}
.boder_bottom {
  color: #ff6900;
  border-bottom: 2px solid #ff6900;
}

.paddingallll {
  padding: 0;
}

.toptabicon {
  width: 60px;
  height: 60px;
  display: block;
  margin: auto 0;
  display: none;
}

.toptabicon img {
  width: 60px;
  height: 60px;
  display: block;
  margin: auto 0;
}

.ularea {
  width: 100%;
  height: 100vh;
  background-color: #53565a;
  position: relative;
  z-index: 200;
  padding-top: 1.15rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}
.ulclose {
  position: absolute;
  top: 0.6rem;
  right: 0.4rem;
}

.ulclose img {
  width: 80px;
  height: 80px;
}

.ulimg {
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 12%;
}
.ulimg img {
  width: 80%;
  display: block;
  margin: 0 auto;
}
.ulword {
  text-align: center;
  color: white;
  font-size: 0.225rem;
  margin-top: 3.6rem;
}

.tabstab {
  width: 60%;
  height: 0.5rem;
  line-height: 100px;
  font-size: 60px;
  color: white;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.tabstab li.itemtabtab {
  text-align: center;
  border-bottom: 1px solid white;
  margin-bottom: 0.8rem;
}

.aaa {
  position: absolute;
  top: 0;
  left: 0;
}
@media (max-width: 1640px) {
  .paddingallll {
    padding: 0 1rem;
  }
  .tab {
    width: 100%;
  }
}
@media (max-width: 1440px) {
  .paddingallll {
    padding: 0 0.4rem;
  }
  .tab {
    width: 100%;
  }
}

@media (max-width: 1300px) {
  .tabs {
    font-size: 14px;
  }
  .tabs li {
    margin-left: 20px;
  }
  .abouttwo {
    font-size: 12px;
  }
}

@media (max-width: 992px) {
  .toptabicon {
    display: block;
  }
  .tabs {
    display: none;
  }
  .whiteoutertab {
    height: 100px;
  }

  .tab {
    height: 100px;
  }

  .tablogo {
    height: 60px;
    margin: auto 0;
  }

  .tablogo img {
    height: 60px;
    display: block;
  }

  .toptabicon {
    width: 80px;
    height: 80px;
  }

  .toptabicon img {
    width: 80px;
    height: 80px;
  }
  .toplink {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top-tab-item.vue